export const getRailsStatusItems = () => [
  { text: 'Active' },
  { text: 'In Place' },
  { text: 'Available' },
  { text: 'Unavailable' },
];
